"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Collection of constrains for all fields.
 * TODO: if the file is getting too big, we need to find a better way to split the codes.
 */
var Constraint = /** @class */ (function () {
    function Constraint() {
    }
    Object.defineProperty(Constraint, "required", {
        get: function () {
            return {
                presence: {
                    allowEmpty: false,
                    message: '^required',
                },
                length: {
                    minimum: 1,
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Constraint, "phoneNumber", {
        get: function () {
            return {
                presence: {
                    allowEmpty: false,
                    message: '^phone_number_required',
                },
                format: {
                    pattern: '^0[1-9]\\d{0,3}-\\d{1,4}-\\d{3,4}$',
                    message: '^phone_number_telCheck',
                },
                length: {
                    minimum: 12,
                    maximum: 13,
                    message: '^phone_number_rangelength',
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Constraint, "phoneNumberWorld", {
        get: function () {
            return {
                format: {
                    pattern: '[0-9\\-−‐ー+＋]+$',
                    message: '^phone_number_worldTelCheck',
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Constraint, "firstName", {
        get: function () {
            return {
                presence: {
                    allowEmpty: false,
                    message: '^first_name_required',
                },
                length: {
                    maximum: 40,
                    message: '^first_name_maxlength',
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Constraint, "lastName", {
        get: function () {
            return {
                presence: {
                    allowEmpty: false,
                    message: '^last_name_required',
                },
                length: {
                    maximum: 40,
                    message: '^last_name_maxlength',
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Constraint, "companyName", {
        get: function () {
            return {
                presence: {
                    allowEmpty: false,
                    message: '^company_name_required',
                },
                length: {
                    maximum: 70,
                    message: '^company_name_maxlength',
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Constraint, "officeName", {
        get: function () {
            return {
                length: {
                    maximum: 100,
                    message: '^office_name_maxlength',
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Constraint, "departmentName", {
        get: function () {
            return {
                presence: {
                    allowEmpty: false,
                    message: '^department_required',
                },
                length: {
                    maximum: 255,
                    message: '^department_maxlength',
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Constraint, "businessType", {
        get: function () {
            return {
                presence: {
                    allowEmpty: false,
                    message: '^business_types_required',
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Constraint, "jobCategoryType", {
        get: function () {
            return {
                presence: {
                    allowEmpty: false,
                    message: '^job_category_types_required',
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Constraint, "subdivisionCode", {
        get: function () {
            return {
                presence: {
                    allowEmpty: false,
                    message: '^subdivision_code_required',
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Constraint, "email", {
        get: function () {
            return {
                email: {
                    message: '^clip.email.invalid',
                },
                presence: {
                    allowEmpty: false,
                    message: '^clip.email.required',
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    return Constraint;
}());
exports.default = Constraint;
//# sourceMappingURL=Constraint.js.map